import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import styled from "styled-components";
import { Colors } from "../../config";
import OnBoardingHeader from "./OnBoardingHeader";
import OnBoradingSubHeader from "./OnBoradingSubHeader";
import RequestTicketIcon from "../../assets/Icons/RequestTicketIcon";

const ThirdCarousal = () => {
  return (
    <BoxContainer>
      <ImageContainer>
        <RequestTicketIcon />
      </ImageContainer>
      <OnBoardingHeader header="Request Status" />
      <SubTextContainer>
        <OnBoradingSubHeader
          color={Colors.brandOne}
          header="Never lose track of your travel requests."
        />
        <br></br>
        <OnBoradingSubHeader
          color={Colors.ashBlue}
          header="Our app lets you view all of your requests and their status, and even chat with Joury if you need to make any updates or changes."
        />
      </SubTextContainer>
      {/* <MainContainer>
        
      </MainContainer> */}
    </BoxContainer>
  );
};

const BoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  /* border-radius: 5px;
  padding: 20px; */
  align-items: center;
  border-radius: 1.25rem;
  /* @media only screen and (max-width: 478px) {
    width: 15.625rem;
  } */
  /* max-height: 43.75rem;
  margin-left: 40rem;
  margin-right: 40rem; */
`;

const ImageContainer = styled.div`
  align-items: center;
  justify-content: center;
  width: 30rem;
  height: 17rem;
  margin-top: 2rem;
  margin-bottom: 3.393rem;
  /* @media only screen and (max-width: 478px) {
    width: 15.625rem;
  } */
  object-fit: contain;
`;
const SubTextContainer = styled.div`
  /* display: flex; */
  flex-direction: column;
  margin-bottom: 2rem;
  max-width: 28rem;
  @media only screen and (max-width: 478px) {
    width: 22rem;
  }
`;

const MainContainer = styled.div`
  /* flex-direction: column; */
  background-color: "red";
  margin-block-start: 19rem;
`;

export default ThirdCarousal;
